import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

export type CampoDinamicoMotivoPadrao = Readonly<{
  id: string
  nome: string
  tipo: 'TEXTO' | 'OPCOES'
  obrigatorio: boolean
  opcoes: readonly Readonly<{ valor: string }>[]
}>

export type OpcaoMotivoPadrao = Readonly<{
  id: string
  description: string
  code?: string | null
  kind?: string | null
  active?: boolean | null
  todos_os_campos_medicos_obrigatorio?: boolean | null
  profissional_de_saude_exibir?: boolean | null
  profissional_de_saude_obrigatorio?: boolean | null
  numero_da_classe_exibir?: boolean | null
  numero_da_classe_obrigatorio?: boolean | null
  classe_do_profissional_exibir?: boolean | null
  classe_do_profissional_obrigatorio?: boolean | null
  estado_exibir?: boolean | null
  estado_obrigatorio?: boolean | null
  especialidade_exibir?: boolean | null
  especialidade_obrigatorio?: boolean | null
  clinica_exibir?: boolean | null
  clinica_obrigatorio?: boolean | null
  cnpj_exibir?: boolean | null
  cnpj_obrigatorio?: boolean | null
  cid_exibir?: boolean | null
  cid_obrigatorio?: boolean | null
  declaracao_de_comparecimento_exibir?: boolean | null
  declaracao_de_comparecimento_obrigatorio?: boolean | null
  atestado_de_dispensa_exibir?: boolean | null
  atestado_de_dispensa_obrigatorio?: boolean | null
  justificativa_incide_no_absenteismo?: boolean | null
  pedir_nota_a_esse_motivo_padrao?: boolean | null
  declaracao_de_comparecimento_valor_padrao?: boolean | null
  atestado_de_dispensa_valor_padrao?: boolean | null
  anexo_de_arquivos_exibir?: boolean | null
  anexo_de_arquivos_obrigatorio?: boolean | null
  tempo_de_deslocamento_exibir?: boolean | null
  tempo_de_deslocamento_obrigatorio?: boolean | null
  duracao_esperada_da_pausa_exibir?: boolean | null
  descontar_dsr_exibir?: boolean | null
  descontar_dsr_obrigatorio?: boolean | null
  descontar_dsr_valor_padrao?: boolean | null
  ignorar_jornada_de_folga_exibir?: boolean | null
  ignorar_jornada_de_folga_obrigatorio?: boolean | null
  ignorar_jornada_de_folga_valor_padrao?: boolean | null
  calculo_de_dispensa_exibir?: boolean | null
  calculo_de_dispensa_valor_padrao?: string | null
  campos_dinamicos_esperados?: readonly CampoDinamicoMotivoPadrao[] | null
}>

export type FiltrosCatalogoMotivoPadrao = Readonly<{
  active?: boolean
  kind?: readonly string[]
}>
export type SelecaoCatalogoMotivoPadrao = OpcaoMotivoPadrao | readonly OpcaoMotivoPadrao[] | null
export type OperacoesCatalogoMotivoPadrao = Readonly<{
  listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoMotivoPadrao[]>
}>

export const CAMPOS_PROJECAO_MOTIVO_PADRAO = [
  'id',
  'description',
  'code',
  'kind',
  'active',
  'todos_os_campos_medicos_obrigatorio',
  'profissional_de_saude_exibir',
  'profissional_de_saude_obrigatorio',
  'numero_da_classe_exibir',
  'numero_da_classe_obrigatorio',
  'classe_do_profissional_exibir',
  'classe_do_profissional_obrigatorio',
  'estado_exibir',
  'estado_obrigatorio',
  'especialidade_exibir',
  'especialidade_obrigatorio',
  'clinica_exibir',
  'clinica_obrigatorio',
  'cnpj_exibir',
  'cnpj_obrigatorio',
  'cid_exibir',
  'cid_obrigatorio',
  'declaracao_de_comparecimento_exibir',
  'declaracao_de_comparecimento_obrigatorio',
  'atestado_de_dispensa_exibir',
  'atestado_de_dispensa_obrigatorio',
  'justificativa_incide_no_absenteismo',
  'pedir_nota_a_esse_motivo_padrao',
  'declaracao_de_comparecimento_valor_padrao',
  'atestado_de_dispensa_valor_padrao',
  'anexo_de_arquivos_exibir',
  'anexo_de_arquivos_obrigatorio',
  'tempo_de_deslocamento_exibir',
  'tempo_de_deslocamento_obrigatorio',
  'duracao_esperada_da_pausa_exibir',
  'descontar_dsr_exibir',
  'descontar_dsr_obrigatorio',
  'descontar_dsr_valor_padrao',
  'ignorar_jornada_de_folga_exibir',
  'ignorar_jornada_de_folga_obrigatorio',
  'ignorar_jornada_de_folga_valor_padrao',
  'calculo_de_dispensa_exibir',
  'calculo_de_dispensa_valor_padrao',
  'campos_dinamicos_esperados',
] as const
const campos = new Set<string>(CAMPOS_PROJECAO_MOTIVO_PADRAO)
const registro = (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null && !Array.isArray(v)
const somenteCampos = (v: unknown, nomes: readonly string[]): boolean => !registro(v) || Object.keys(v).every(c => nomes.includes(c))

export const DESCRITOR_CATALOGO_MOTIVO_PADRAO: CatalogoDescriptor<OpcaoMotivoPadrao> = Object.freeze({
  nome: 'motivos-padrao',
  versaoProjecao: 2,
  validarItens: (valor: unknown): valor is readonly OpcaoMotivoPadrao[] => (
    Array.isArray(valor) && valor.every(item => registro(item)
      && Object.keys(item).every(c => campos.has(c))
      && (!Array.isArray(item.campos_dinamicos_esperados) || item.campos_dinamicos_esperados.every((campo: unknown) => (
        somenteCampos(campo, ['id', 'nome', 'tipo', 'obrigatorio', 'opcoes'])
        && (!registro(campo) || !Array.isArray(campo.opcoes) || campo.opcoes.every((opcao: unknown) => somenteCampos(opcao, ['valor'])))
      ))))
  ),
})
